'use strict';

/** Import LocationHandler class */
import LocationHandler from '../location_handler/location_handler';

/** Import ErrorHandler class */
import ErrorHandler from '../error_handler/error_handler';

/**
 * @class AjaxHandler
 */
class AjaxHandler
{
    /**
     * @param link
     * @returns {*}
     */
    get (link)
    {
        let requestData = {
            url: LocationHandler.getBaseUrl() + '/' + link,
            method: 'GET',
            error: this.constructor._onError
        };
        return this.constructor._xhrCall(requestData);
    }

    /**
     * @param link
     * @param data
     * @returns {*}
     */
    post (link, data)
    {
        let requestData = {
            url: LocationHandler.getBaseUrl() + '/' + link,
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            contentType: "application/json",
            dataType: 'json',
            data: this.constructor._stringifyData(data),
            error: this.constructor._onError
        };
        return this.constructor._xhrCall(requestData);
    }

    /**
     * @param link
     * @param data
     * @returns {*}
     */
    put (link, data)
    {
        let requestData = {
            url: LocationHandler.getBaseUrl() + '/' + link,
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            contentType: "application/json",
            dataType: 'json',
            data: this.constructor._stringifyData(data),
            error: this.constructor._onError
        };
        return this.constructor._xhrCall(requestData);
    }

    /**
     * @param link
     * @returns {*}
     */
    remove (link)
    {
        let requestData = {
            url: LocationHandler.getBaseUrl() + '/' + link,
            method: 'DELETE',
            error: this.constructor._onError
        };
        return this.constructor._xhrCall(requestData);
    }

    /**
     * @param response
     * @private
     */
    static _onError (response)
    {
        ErrorHandler.handleError(response.status, response.statusText);
    }

    /**
     * @param data
     * @returns {*}
     * @private
     */
    static _xhrCall (data)
    {
        return $.ajax(data);
    }

    /**
     * @param data
     * @returns {string}
     * @private
     */
    static _stringifyData (data)
    {
        return JSON.stringify(data);
    }
}

/** @export AjaxHandler */
export default new AjaxHandler();


// WEBPACK FOOTER //
// ./assets/js/shared/utility/ajax_handler/ajax_handler.js